<template>
  <pt-coupon-review class="pt-coupon-review__page"></pt-coupon-review>
</template>

<script>
import PtCouponReview from 'cps/mall-manage/pt-coupon-review/withData'
export default {
  name: 'pt-coupon-review__view',
  components: {
    'pt-coupon-review': PtCouponReview
  }
}
</script>
